'use client'

import { createContext, useContext, ReactNode } from 'react'

// Контекст для публичного режима просмотра (отключён — isPublicMode всегда false)
interface PublicModeContextType {
  isPublicMode: boolean
  togglePublicMode: () => void
  setPublicMode: (value: boolean) => void
}

const PublicModeContext = createContext<PublicModeContextType | undefined>(undefined)

export function PublicModeProvider({ children }: { children: ReactNode }) {
  // Режим просмотра отключён — всегда false
  const togglePublicMode = () => {}
  const setPublicMode = (_value: boolean) => {}

  return (
    <PublicModeContext.Provider value={{ isPublicMode: false, togglePublicMode, setPublicMode }}>
      {children}
    </PublicModeContext.Provider>
  )
}

// Хук для использования контекста публичного режима
export function usePublicMode() {
  const context = useContext(PublicModeContext)
  if (context === undefined) {
    throw new Error('usePublicMode must be used within a PublicModeProvider')
  }
  return context
}
